module.exports = __webpack_public_path__ + "static/image-3-b6d21307e84ce361613901ecf0c79f3e.png";